import { AxiosRequestConfig, AxiosResponse } from 'axios';
import api from './axios';

export const swrFetcher = <T = any, R = AxiosResponse<T>>(
  url: string,
  config:  AxiosRequestConfig
): Promise<R> => {
  return api.get(url, config );
};
